export const localePrefixes = {
  'zh-Hans': '/zh-cn',
  'zh-Hant': '/zh-cht',
};
